export const SuccessResponseCodeList = ["00", "0000"];